// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "fareType_active-F4HqV";
var _3 = "fares__dotsList-1MD-5";
var _4 = "flight_withAircraft-2o4MY";
var _5 = "price-13Eel";
var _6 = "price__money-bhLWf";
export { _1 as "__esModule", _2 as "fareType_active", _3 as "fares__dotsList", _4 as "flight_withAircraft", _5 as "price", _6 as "price__money" }
export default { "__esModule": _1, "fareType_active": _2, "fares__dotsList": _3, "flight_withAircraft": _4, "price": _5, "price__money": _6 }
